import { Injectable } from '@angular/core';
import { DatabaseModel } from '../models/database-model';
import { BehaviorSubject } from 'rxjs';

export enum ToastType {
    INFO = 'INFO',
    ERR = 'ERR',
    OK = 'OK'
}

export interface ToastAction {
    label: string,
    callback: () => void,
}

export interface Toast {
    msg: string,
    type: ToastType,
    icon: string,
    id: string,
    showCloseOption: boolean,
    action?: ToastAction,
};

@Injectable({ providedIn: 'root' })
export class ToastService {

    private toastSub: BehaviorSubject<Toast[]> = new BehaviorSubject([])
    private toasts: Toast[] = [];

    constructor() {
        this.watchToast().subscribe((toasts: Toast[]) => {
            if(!toasts) return;
            // console.log(toasts);
        })
    }

    /**
     * Show a toast message for a given period of time.
     * @duration Number of ms to show the toast. If -1 is given the toast will be shown infinitely (remember to remove it with the returned id)
     */
    public addToast(message: string, type: ToastType = ToastType.INFO, duration: number = 5000, showCloseOption: boolean = true, action?: ToastAction ):  { awaitToastClose: Promise<string>, id: string } {
        const newToast = { msg: message, type: type, icon: this.getIcon(type), id: DatabaseModel.genKey(), showCloseOption, action };
        // Add toast to array and notify observers
        this.toasts.push(newToast);
        this.toastSub.next(this.toasts);
        // Show toast forever in case duration in set to negative
        if(duration <= -1) return { awaitToastClose: Promise.resolve(message), id: newToast.id }

        const awaitToastClose: Promise<string> = new Promise((resolve, reject) => {
            // Remove toast from array after a given time (if it still exists in the array)
            setTimeout(() => {
                this.toasts = this.toasts.filter(toast => toast.id != newToast.id);
                this.toastSub.next(this.toasts);
                resolve(message);
            }, duration);
        });

        return { awaitToastClose, id: newToast.id }
    }

    public removeToast(toastId: string) : void {
            // Remove toast from toast list
            this.toasts = this.toasts.filter(toast => toast.id != toastId);
            // Notify listeners
            this.toastSub.next(this.toasts);
    }

    public watchToast(): BehaviorSubject<Toast[]> {
        return this.toastSub;
    }

    private getIcon(type: ToastType): string {
        return type == ToastType.ERR ? 'toast-err' : (type == ToastType.OK) ? 'toast-ok' : 'toast-info';
    }
}
